import { fetcher } from '../../utils/fetchers/fetcher';
import { resolveApiPath } from '../../utils/resolveApiPath';
import { Layout } from '../../../types/types';

// GET whole layout content. Path is resolved from the definition's apiMethods.get.
export const requestLayout = (
  path: string,
  token: string | null,
  forceHeader?: string
): Promise<Layout> =>
  fetcher<Layout>(resolveApiPath(path), 'GET', token, forceHeader);
